import { render, staticRenderFns } from "./OfferEdit.vue?vue&type=template&id=512f6e2f&"
import script from "./OfferEdit.vue?vue&type=script&lang=js&"
export * from "./OfferEdit.vue?vue&type=script&lang=js&"
import style0 from "./OfferEdit.vue?vue&type=style&index=0&id=512f6e2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports